import { FC, useEffect, useRef } from 'react';
import {
  ImagesEnum,
  useImagesContext,
} from '../../../../../providers/StartProvider/ImagesProvider';
import { drawButton } from '../../utils/drawing';
import * as WinterItems from '../../items/winterItems';
import { pointsToDraw } from '../constants';
import BlockObject from '../../BlockObject';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../stores';
import { useTranslation } from 'react-i18next';

type MainObjHighSchoolMapProps = {
  className?: string;
};

const MainObjHighSchoolMap: FC<MainObjHighSchoolMapProps> = ({ className }) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const drawBackground = (ctx: CanvasRenderingContext2D) => {
    ctx.fillStyle = '#2D396B';
  };
  const currentSubjectId = useSelector(
    (state: RootState) => state.start.currentSubjectId
  );
  const subjectDetails = useSelector(
    (state: RootState) => state.start.subjectDetails
  );
  const { t, i18n } = useTranslation(['translation']);
  const language = i18n.language;

  const { getImage, images, isLoaded } = useImagesContext();

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      const ctx = canvas.getContext('2d');

      if (ctx && isLoaded) {
        ctx.imageSmoothingEnabled = false;
        canvas.width = 960;
        canvas.height = 960;
        drawBackground(ctx);
        BlockObject({
          ctx,
          objects: pointsToDraw,
          offsetX: 0,
          offsetY: 0,
          images,
        });

        const buttonBackgroundImg = getImage(ImagesEnum.Button1);
        const buttonIconImg = getImage(ImagesEnum.EmojiEvents);
        const lockClosedButtonImg = getImage(ImagesEnum.LockClosed);
        const subjectData = subjectDetails?.[language]?.find(
          (data) => data.subjectId === currentSubjectId
        );

        if (subjectData?.levelProgress === 1 && subjectData?.subjectLevel === 12) {
          drawButton(
            ctx,
            436.67,
            266.34,
            86.7,
            38.1,
            buttonBackgroundImg!,
            buttonIconImg
          );
        } else {
          drawButton(
            ctx,
            436.67,
            266.34,
            86.7,
            38.1,
            buttonBackgroundImg!,
            lockClosedButtonImg
          );
        }
      }
    }
  }, [isLoaded, images, currentSubjectId, subjectDetails, t]);
  return (
    <div className={className}>
      <canvas
        className="scale-100 overflow-hidden"
        ref={canvasRef}
        width={960}
        height={960}
      ></canvas>
    </div>
  );
};

export default MainObjHighSchoolMap;
